import { Button, Image, Types } from '@marriott/mi-ui-library';
import { EditableComponent } from '@adobe/aem-react-editable-components';

import {
  ButtonWrapper,
  PostcardBackground,
  PostcardContent,
  PostcardHolder,
  PostcardSubtitle,
  PostcardTitle,
  StyledImage,
} from './Postcard.styles';
import { POSTCARD_CONSTANTS } from '../../utils';
import { PostcardCTA, PostcardProps } from './Postcard.types';
import { getClickTrackValue } from '../../utils/defaultTrackingUtils';

const PostcardComp = (props: PostcardProps) => {
  const { title, descriptionDesktop, descriptionShort, ctaLinkListItems, dynamicMedia, trackingProperties } = props;

  return (
    <PostcardHolder className="container border postcard-holder">
      <PostcardBackground className="d-flex align-items-center justify-content-center">
        <StyledImage data-testid="background">
          <Image
            defaultImageURL={dynamicMedia?.assetPath}
            altText={dynamicMedia?.altText}
            dynamic={dynamicMedia?.dynamic}
            renditions={dynamicMedia?.renditions}
            title={dynamicMedia?.altText}
            customClass="pc__img"
          />
        </StyledImage>
        <PostcardContent className="col-md-8 d-flex align-items-center flex-column postcard-content">
          <PostcardTitle className="t-title-inverse-m" dangerouslySetInnerHTML={{ __html: title }} />
          {descriptionShort && (
            <PostcardSubtitle
              className="t-subtitle-xl description-short"
              dangerouslySetInnerHTML={{
                __html: descriptionShort,
              }}
            />
          )}
          <PostcardSubtitle
            className="t-subtitle-xl description-desktop"
            dangerouslySetInnerHTML={{
              __html: descriptionDesktop,
            }}
          />

          <ButtonWrapper className="d-flex justify-content-center flex-column flex-md-row">
            {ctaLinkListItems?.map((postcardCTA: PostcardCTA, index) => {
              return (
                <Button
                  key={index}
                  href={postcardCTA?.ctaLinkURL}
                  isLink={true}
                  target={postcardCTA?.openInaNewTab ? '_blank' : undefined}
                  rel={postcardCTA?.openInaNewTab ? 'noopener noreferrer' : undefined}
                  type={Types.ButtonTypeVariation.Button}
                  trackingProperties={trackingProperties}
                  className="m-button-s m-button-primary-inverse"
                  custom_click_track_value={getClickTrackValue({
                    trackingProperties: {
                      ...trackingProperties,
                      trackingDescription: postcardCTA?.ctaTrackingDescription || '',
                      trackingContentPosition: trackingProperties?.trackingDescription,
                    },
                    url: postcardCTA?.ctaLinkURL,
                    fallbacks: {
                      position: POSTCARD_CONSTANTS['POSITION'],
                      description: postcardCTA?.ctaTrackingDescription || '',
                    },
                  })}
                >
                  {postcardCTA?.ctaLabel}
                </Button>
              );
            })}
          </ButtonWrapper>
        </PostcardContent>
      </PostcardBackground>
    </PostcardHolder>
  );
};

export const Postcard = (props: PostcardProps) => {
  return props.isAuthorMode ? (
    <EditableComponent
      config={{
        emptyLabel: 'postcard',
        isEmpty: () => false,
        resourceType: 'mi-aem-homepage-spa/components/content/postcard',
      }}
      {...props}
    >
      <PostcardComp {...props} />
    </EditableComponent>
  ) : (
    <PostcardComp {...props} />
  );
};
